import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=9569c61e&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts&"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=9569c61e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9569c61e",
  null
  
)

export default component.exports